<!--  title -->
<template>
  <div class="title">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'base-title'
}
</script>
<style lang="stylus" scoped>

.title
  font-family  fonts!important
  font-size $font-size-md!important
  text-align left
  color: $info-color
  font-weight bolder!important
</style>
